import React, { memo } from "react";

import { IconOld } from "@partials";
import { ExchangeRatesTableType } from "@constants";
import { getLocalization } from "@utilities";

import { ExchangeTableRowItem, LocalizationTexts } from "../types";

export interface TableHintProps {
  localization: LocalizationTexts;
  type: ExchangeRatesTableType;
}

type RatesTableProps = {
  items: ExchangeTableRowItem[];
  localization: LocalizationTexts;
  type: ExchangeRatesTableType;
};

const RatesTable: React.FC<RatesTableProps> = ({ items, localization, type }) => {
  if (!items) return null;

  const getArrow = (trend: number) => {
    if (trend > 0) {
      return (
        <span style={{ fill: "#267C29" }}>
          <svg
            width="10"
            height="10"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.63166 7.54545L0.449841 7.54545L4.54075 0.590909L8.63166 7.54545Z"
              fill="#267C29"
            />
          </svg>
        </span>
      );
    }
    if (trend < 0) {
      return (
        <span style={{ fill: "#E00000" }}>
          <svg
            width="10"
            height="10"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.368342 0.454545H8.55016L4.45925 7.40909L0.368342 0.454545Z"
              fill="#E00000"
            />
          </svg>
        </span>
      );
    }
    return (
      <span style={{ fill: "#E26E52" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 7 10"
          fill="none"
        >
          <path d="M0 9.09082L-3.57639e-07 0.909001L6.95455 4.99991L0 9.09082Z" fill="#E26E52" />
        </svg>
      </span>
    );
  };

  return (
    <div className="table-exrate" data-id={type} data-testid={`rates-table-${type}`}>
      <div className="table-exrate-header">
        <div className="table-exrate-row mb-0">
          <div className="table-exrate-cell table-exrate-cell--header table-exrate-cell--empty-country-name" />
          <div className="table-exrate-cell table-exrate-cell--header">
            {getLocalization(localization, "Currency")}
          </div>
          <div className="table-exrate-cell table-exrate-cell--header">
            {getLocalization(localization, "Buy")}
          </div>
          <div className="table-exrate-cell table-exrate-cell--header">
            {getLocalization(localization, "Sell")}
          </div>
          <div className="table-exrate-cell table-exrate-cell--header">
            {getLocalization(localization, "CnbMiddle")}
          </div>
        </div>
      </div>

      <div className="table-exrate__body">
        {items.map((item) => {
          return (
            <div className="table-exrate-row table-exrate-row-sk sm:!mb-0">
              <div className="table-exrate-cell table-exrate-country-name">
                <div>
                  <IconOld name={item.icon} className="mr-4 inline h-8 w-8 sm:mx-4" />
                  <span className="font-semibold">{item.title}</span>
                </div>
                <div className="table-exrate-icon-arrow-mobile flex items-center mr-[7px]">
                  {getArrow(item.trend)}
                </div>
              </div>

              <div
                className="table-exrate-cell"
                data-title={getLocalization(localization, "Currency")}
              >
                {item.currencyUnit} {item.curencyIso}
              </div>
              <div className="table-exrate-cell" data-title={getLocalization(localization, "Buy")}>
                {type === ExchangeRatesTableType.Cash ? item.cashBuyStr : item.nonCashBuyStr}
              </div>
              <div className="table-exrate-cell" data-title={getLocalization(localization, "Sell")}>
                {type === ExchangeRatesTableType.Cash ? item.cashSellStr : item.nonCashSellStr}
              </div>
              <div
                className="table-exrate-cell penultimate"
                data-title={getLocalization(localization, "CnbMiddle")}
              >
                {item.middleCNBStr}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(RatesTable);
